import React from 'react';
import { Icon } from 'semantic-ui-react';
import * as Styles from '../view-all-tickets/ViewAllTickets.styles';
import { Link, useHistory } from 'react-router-dom';
import { Hidden } from '@mui/material';
import { H6, P } from 'utils/resuable-css';
import { Base64 } from 'js-base64';

const TicketsDetailContainer = ({ val, department, subStatus, handlePortalLogin, loadingUrl }) => {
  let history = useHistory();
  return (
    <Styles.Issue>
      <Hidden only={['xs', 'sm']}>
        <Styles.Container>
          <Styles.First>
            <Styles.UserNameLinks>
              <Link className="firstLink" to="/dashboard">
                {val.vip === '1' && <Icon name="chess queen" className="crown" size="large" />}
                {val.paid === '1' && <Icon name="dollar" className="dollar" size="large" />}
                <H6>{val.username}</H6>
                <Icon name="warning circle" className="warning" />
              </Link>
              <Styles.DevLiveLink loading={loadingUrl}>
                <div className="link" onClick={() => handlePortalLogin('dev', val.username)}>
                  <H6>dev</H6>
                  <Icon name="sign-in" />
                  <H6 style={{ margin: '0', marginTop: '5px' }}>|</H6>
                </div>
                <div className="link" onClick={() => handlePortalLogin('live', val.username)}>
                  <H6>live</H6>
                  <Icon name="sign-in" />
                </div>
              </Styles.DevLiveLink>
            </Styles.UserNameLinks>
            <Styles.DeparmentName>
              <P>{department?.title_en} </P>
            </Styles.DeparmentName>
          </Styles.First>
          <Styles.Second>
            <div style={{ display: 'flex' }}>
              <Link to={`/admin/tickets/${val.id}`}>
                <H6
                  onClick={(event) => {
                    if (!event.ctrlKey) {
                      history.replace(`/admin/tickets/${val.id}`);
                    }
                  }}
                >
                  {val.subject && Base64.decode(val.subject)}{' '}
                </H6>
              </Link>
              <Link target="_blank" to={`/admin/tickets/${val.id}`}>
                <Icon style={{ marginLeft: '5px' }} name="external alternate" />
              </Link>
            </div>

            <P>
              Issue ID #{val.id}
              <br /> opened on {val.date_local_format_mdy}
            </P>
          </Styles.Second>
          <Styles.Last>
            <Styles.Time>
              <P>{val.time_opened_ago_en}</P>
            </Styles.Time>
            <Styles.Third>
              <Styles.IssueName style={{ background: `#${subStatus?.color}`, color: `#${subStatus?.font_color}` }}>
                <P>{subStatus?.title_en} </P>
              </Styles.IssueName>
            </Styles.Third>
            <div className="righticon">
              <Icon name="comment outline" />
              <P>{val?.message_count}</P>
            </div>
          </Styles.Last>
        </Styles.Container>
      </Hidden>

      <Hidden only={['md', 'lg', 'xl']}>
        <Styles.MobileContainer>
          <Styles.MobileFirst>
            <Styles.IssueName style={{ background: `#${subStatus?.color}`, color: `#${subStatus?.font_color}` }}>
              <P>{subStatus?.title_en} </P>
            </Styles.IssueName>
            <Styles.DevLiveLink loading={loadingUrl}>
              <div className="link" onClick={() => handlePortalLogin('dev', val.username)}>
                <H6>dev</H6>
                <Icon name="sign-in" />
                <H6 style={{ margin: '0', marginTop: '5px' }}>|</H6>
              </div>
              <div className="link" onClick={() => handlePortalLogin('live', val.username)}>
                <H6>live</H6>
                <Icon name="sign-in" />
              </div>
            </Styles.DevLiveLink>
          </Styles.MobileFirst>
          <Styles.MobileSecond
            onClick={(event) => {
              if (!event.ctrlKey) {
                history.replace(`/admin/tickets/${val.id}`);
              }
            }}
          >
            <Link to={`/admin/tickets/${val.id}`} style={{ display: 'flex' }}>
              <H6>{val.subject && Base64.decode(val.subject)} </H6>
            </Link>
            <P>
              Issue ID #{val.id} opened on {val.date_local_format_mdy} | {val.time_opened_ago_en}
            </P>
          </Styles.MobileSecond>
          <Styles.MobileThird>
            <Styles.MobileUserNameLinks>
              <Link className="firstLink" to="/dashboard">
                {val.vip === '1' && <Icon name="chess queen" className="crown" size="large" />}
                {val.paid === '1' && <Icon name="dollar" className="dollar" size="large" />}
                <H6>{val.username}</H6>
                <Icon name="warning circle" className="warning" />
              </Link>
            </Styles.MobileUserNameLinks>
            <Styles.DeparmentFlex>
              <Styles.MobileDeparmentName>
                <P>{department?.title_en} </P>
              </Styles.MobileDeparmentName>
              <div className="righticon">
                <Icon name="comment outline" />
                <P>{val?.message_count}</P>
              </div>
            </Styles.DeparmentFlex>
          </Styles.MobileThird>
        </Styles.MobileContainer>
      </Hidden>
    </Styles.Issue>
  );
};

export default TicketsDetailContainer;
